var ValueJS = ValueJS || {};

ValueJS.FixedNavbar = function() {

    var _window = $(window);

    var _body = $('body');

    var _navbar = $('.navbar');
    var _navbarHeight = _navbar.height();

    var _init = function() {
        if ($('body').hasClass('page-template-front-page')) {
            _window.on('scroll', _update);
            _update();
        }
    }

    var _update = function() {
        if (_window.scrollTop() > 200) {
            _navbar.addClass('navbar--scrolled');
        } else {
            _navbar.removeClass('navbar--scrolled');
        }
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

$(function() {
    ValueJS.FixedNavbar.init();
});
